var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentDevicesOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20v-3h2V6c0-.55.196-1.02.588-1.412A1.926 1.926 0 016 4h15v2H6v11h6v3H2zm13 0a.968.968 0 01-.713-.287A.968.968 0 0114 19V9a.97.97 0 01.287-.712A.968.968 0 0115 8h6c.283 0 .52.096.712.288A.965.965 0 0122 9v10a.967.967 0 01-.288.713A.968.968 0 0121 20h-6zm1-3h4v-7h-4v7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentDevicesOutline);
export default __webpack_public_path__ + "c438d0de3322ef680d268b848a962ca7.svg";
export { ForwardRef as ReactComponent };